const ROLE_ALIASES = {
  admin: "clinic_admin",
};

const ROUTE_ROLES = {
  "/": ["staff"],
  "/patients": ["staff"],
  "/doctors": ["staff"],
  "/services": ["clinic_admin"],
  "/samples": ["clinic_admin", "receptionist", "doctor", "lab_staff"],
  "/report-extract": ["clinic_admin", "receptionist", "doctor", "lab_staff"],
  "/report-standardizer": ["clinic_admin", "doctor"],
  "/prescriptions": ["clinic_admin", "doctor", "receptionist"],
  "/reports": ["clinic_admin", "accountant"],
  "/billing": ["clinic_admin", "receptionist", "accountant"],
  "/attendance": ["clinic_admin", "receptionist", "accountant"],
  "/employees": ["clinic_admin", "accountant", "receptionist"],
  "/payroll": ["clinic_admin", "accountant"],
  "/expenses": ["clinic_admin", "accountant"],
  "/analytics": ["clinic_admin", "accountant"],
  "/integrations": ["clinic_admin"],
  "/imports": ["clinic_admin"],
  "/settings": ["clinic_admin"],
  "/menu": ["staff"],
};

const ROLE_GROUPS = {
  staff: ["clinic_admin", "receptionist", "doctor", "lab_staff", "accountant"],
  clinic_admin: ["clinic_admin"],
  super_admin: ["super_admin"],
};

export function normalizeRole(role) {
  return ROLE_ALIASES[role] || role || "";
}

export function hasRole(user, allowedRoles = []) {
  const role = normalizeRole(user?.role);
  if (role === "super_admin") return true;

  const expanded = allowedRoles.flatMap((item) => ROLE_GROUPS[item] || [item]);
  return expanded.map(normalizeRole).includes(role);
}

export function canAccessPath(user, path) {
  const route = Object.keys(ROUTE_ROLES)
    .filter((item) => path === item || (item !== "/" && path.startsWith(item)))
    .sort((a, b) => b.length - a.length)[0];

  return hasRole(user, ROUTE_ROLES[route] || ["staff"]);
}

export function visibleNavItems(user, navItems) {
  return navItems.filter((item) => canAccessPath(user, item.path));
}
